import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

const validateLoader = ({ message }) => {
  return <Spinner fullScreen show label={message} />;
};

validateLoader.propTypes = {
  message: PropTypes.string.isRequired
};

export default validateLoader;
